import OrderModel from '@Model/OrderModel';
import RecentOrderModel from '@Model/RecentOrderModel';
var state = {
    order: null,
    delayTime: 0,
    delayType: 0,
};
var getters = {
    getOrder: function (state) { return state.order; },
    getDelay: function (state) { return state.delayTime; },
    getDelayType: function (state) { return state.delayType; },
};
var actions = {
    setOrder: function (_a, order) {
        var commit = _a.commit;
        commit('setOrder', order);
    },
    setDelay: function (_a, delayTime) {
        var commit = _a.commit;
        commit('setDelay', delayTime);
    },
    setDelayType: function (_a, delayType) {
        var commit = _a.commit;
        commit('setDelayType', delayType);
    },
};
var mutations = {
    setOrder: function (state, order) {
        var isOrder = order instanceof OrderModel;
        var isRecentOrder = order instanceof RecentOrderModel;
        var useOrder = order;
        if (isRecentOrder) {
            order['hydrationStrategy'] = 'hydrateFromRecentOrder';
        }
        if (!isOrder) {
            useOrder = new OrderModel(order);
        }
        state.order = useOrder;
    },
    setDelay: function (state, delayTime) {
        state.delayTime = delayTime;
    },
    setDelayType: function (state, delayType) {
        state.delayType = delayType;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/order.store.ts
// module id = null
// module chunks = 